import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import {useSelector} from "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";


const EmailInquiries = () => {

    const [info, setInfo] = useState()

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const loadEmails = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/home_page_contacts/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/home_page_contacts/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        // console.log(data)
        setInfo(data)
    }

    useEffect(() => {
        loadEmails()
    }, []);


    return (
        <div style={{textAlign: 'center', padding: '20px 0'}}>
            <Row>
                <Col>
                    <h2>Not Responded</h2>
                    {
                        info?.map(item =>
                            <Row key={item.created} style={{padding: '0 10px'}}>
                                {
                                    item.done === 'No' || item.done === ''
                                        ?
                                        (
                                            <Link
                                                className={'btn btn-danger'}
                                                to={`/home_page_contact/${item.id}/`}
                                                style={{margin: '10px 0'}}
                                            >
                                                {item.name}
                                            </Link>
                                        )
                                        :
                                        (
                                            ''
                                        )
                                }
                            </Row>
                        )
                    }
                </Col>
                <Col>
                    <h2>Responded</h2>
                    {
                        info?.map(item =>
                            <Row key={item.created} style={{padding: '0 10px'}}>
                                {
                                    item.done === 'Yes'
                                        ?
                                        (
                                            <Link
                                                className={'btn btn-primary'}
                                                to={`/home_page_contact/${item.id}/`}
                                                style={{margin: '10px 0'}}
                                            >
                                                {item.name}
                                            </Link>
                                        )
                                        :
                                        (
                                            ''
                                        )
                                }
                            </Row>
                        )
                    }
                </Col>
            </Row>
        </div>
    );

};

export default EmailInquiries;